import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

import {
  IonContent,
  IonTitle,
  modalController,
  IonIcon,
} from '@ionic/vue';
import { closeOutline } from 'ionicons/icons';

import { getPlatforms } from '@ionic/vue';
import FileShower from "@/views/file/fileShower.vue";
import FileService from "@/api/file/FileService";


export default /*#__PURE__*/_defineComponent({
  props: {
  file: {
    type: Object,
    required: true,
  }
},
  emits: [
  'dismiss'
],
  setup(__props, { emit: emits }) {

const props = __props




const {
  updateFileUsageTimeStamp,
} = FileService()

//eseguo un refresh del fileOpenedAt e del currentFile
// in modo da salvare il log alla sua chiusura

localStorage.setItem('fileOpenedAt', String((Date.now() / 1000).toFixed(0)))
localStorage.setItem('currentFile', JSON.stringify(props.file))

async function dismissModal() {
  //determino se potrebbe essere un desktop e nel caso non uso la funzione per bloccare la rotazione
  if (!getPlatforms().includes('desktop') && !getPlatforms().includes('mobileweb')) {
    //con await su desktop non funziona la chiusura modal perché non può fare lo screen orientation
    // await ScreenOrientation.lock(ScreenOrientation.ORIENTATIONS.PORTRAIT_PRIMARY)
    // await ScreenOrientation.unlock()
  }
  updateFileUsageTimeStamp()
  localStorage.removeItem('currentFile')
  localStorage.removeItem('fileOpenedAt')
  const modal = await modalController
  return modal.dismiss();
}

return (_ctx: any,_cache: any) => {
  return (__props.file)
    ? (_openBlock(), _createBlock(_unref(IonContent), { key: 0 }, {
        default: _withCtx(() => [
          _createElementVNode("button", {
            class: "dismiss",
            onClick: dismissModal
          }, [
            _createVNode(_unref(IonIcon), {
              slot: "start",
              size: "large",
              ios: _unref(closeOutline),
              md: _unref(closeOutline)
            }, null, 8, ["ios", "md"])
          ]),
          _createVNode(FileShower, { file: __props.file }, null, 8, ["file"])
        ]),
        _: 1
      }))
    : _createCommentVNode("", true)
}
}

})